// SpecialRegisterFormContainer action types and creators

export const REGISTER_USER = 'containers/SpecialRegisterFormContainer/registerUser';
export const REGISTER_USER_SUCCESS = 'containers/SpecialRegisterFormContainer/registerUserSuccess';
export const RELEASE_BUTTON = 'containers/SpecialRegisterFormContainer/releaseButton';

export function registerUser(userData) {
    return {
        type: REGISTER_USER,
        payload: userData,
    };
}

export function registerUserSuccess(userData) {
    return {
        type: REGISTER_USER_SUCCESS,
        payload: userData,
    };
}

export function releaseButton(value) {
    return {
        type: RELEASE_BUTTON,
        payload: value,
    };
}
